  import { Injectable, inject } from "@angular/core";
  import { MsalService } from "@azure/msal-angular";
  import { BehaviorSubject, Observable, of } from "rxjs";

  export interface AuthUser {
    name: string;
    userEmail: string;
    roles: string[];
  }

  @Injectable({
    providedIn: "root",
  })
  export class AuthorizationService {
    private msalService = inject(MsalService);

    private currentUserSubject = new BehaviorSubject<AuthUser | null>(null);

    validateUser(): Observable<AuthUser | null> {
      const account = this.msalService.instance.getAllAccounts()[0];

      if (!account || !account.idTokenClaims) {
        return of(null);
      }

      const roles = account.idTokenClaims.roles && account.idTokenClaims.roles.length > 0 
      ? account.idTokenClaims.roles 
      : ['NO_ROLE'];

      const user: AuthUser = {
        name: account.name ? account.name : '',
        userEmail: account.username,
        roles: roles,
      };

      this.currentUserSubject.next(user);

      return of(user);
    }

    roles(){
      const roles = this.user?.roles && this.user?.roles.length > 0 
      ? this.user?.roles
      : ['NO_ROLE'];

      return roles;
    }

    get user$(): Observable<AuthUser | null> {
      return this.currentUserSubject.asObservable();
    }

    get user(): AuthUser | null {
      return this.currentUserSubject.value;
    }

    hasRole(role: string): boolean {
      return this.user?.roles.includes(role) ?? false;
    }

    get isAdmin(): boolean {
      const isAdmin = this.hasRole('RTM_MASTER') || this.hasRole('CPM_MASTER') || this.hasRole('BRSA_ASSIST_SCANIA_IT');

      return isAdmin;
    }

    public logout() {
      this.msalService.logoutRedirect({
        postLogoutRedirectUri: "https://reflex.scania.com",
      });
    }

    isLoggedIn(): boolean {
      const acc = this.msalService.instance.getActiveAccount() || this.msalService.instance.getAllAccounts()[0];
      return !!acc;
    }

    userHasRole(role: string): boolean {
      return this.hasRole(role);
    }
  }